import React from 'react';
import { render } from 'react-dom';
import MasterApp from './MasterApp/core/MasterApp'
import Summary from './Summary'
import Ytplayer from './Ytplayer'

// // document.addEventListener('DOMContentLoaded', () => {
// //   const container = document.body.appendChild(document.createElement('div'));
// //   render(<MasterApp />, container);
// });





// WEBPACK FOOTER //
// app/javascript/packs/application.js